import { Component, input } from '@angular/core';
import { MDContentBoxComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-announcement-banner',
	standalone: true,
	imports: [MDContentBoxComponent],
	templateUrl: './announcement-banner.component.html',
	styleUrl: './announcement-banner.component.scss'
})
export class AnnouncementBannerComponent {
	type = input<'info' | 'warning' | 'error'>('info');
}
